import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ensure } from 'components/sharpr/ensure/ensure';

let cache = {};

export class TaxonomyService {
	constructor(Api) {
		'ngInject';
		this.Api = Api;
	}

	clearAll() {
		cache = {};
		return this;
	}

	//
	// categories
	//
	getCategories() {
		if (!cache.categories) {
			cache.categories = this.Api.get('/categories');
		}
		return cache.categories;
	}

	static resourcifyCategories() {
		return Taxonomy => {
			'ngInject';
			return Taxonomy.getCategories();
		};
	}

	clearCategories() {
		cache.categories = undefined;
		return this;
	}

	//
	// classifications
	//
	getClassifications() {
		if (!cache.classifications) {
			cache.classifications = this.Api.get('/classifications').then(cls => {
				if (cls && cls.length > 0) {
					AssetManager.css('/assets/fonts/Linearicons/style.css');
				}
				return cls;
			});
		}
		return cache.classifications;
	}

	static resourcifyClassifications() {
		return Taxonomy => {
			'ngInject';
			return Taxonomy.getClassifications();
		};
	}

	clearClassifications() {
		cache.classifications = undefined;
		return this;
	}

	//
	// tags
	//
	getTags() {
		if (!cache.tags) {
			cache.tags = this.Api.get('/tags');
		}
		return cache.tags;
	}

	static resourcifyTags() {
		return Taxonomy => {
			'ngInject';
			return Taxonomy.getTags();
		};
	}

	clearTags() {
		cache.tags = undefined;
		return this;
	}

	//
	// users
	//
	getUsers() {
		if (!cache.users) {
			cache.users = this.Api.get('/users').then(users => {
				cache.clientUserCount = 0;
				ensure.array(users).forEach(user => {
					if (user.role == 'Client') {
						cache.clientUserCount++;
					}
				});
			});
		}
		return cache.users;
	}

	static resourcifyUsers() {
		return Taxonomy => {
			'ngInject';
			return Taxonomy.getUsers();
		};
	}

	clearUsers() {
		cache.users = undefined;
		cache.clientUserCount = undefined;
		return this;
	}

	//
	// client user count
	//
	getClientUserCount() {
		if (!cache.users) {
			return this.getUsers().then(() => {
				return cache.clientUserCount;
			});
		}
		return Promise.resolve(cache.clientUserCount);
	}

	static resourcifyClientUserCount() {
		return Taxonomy => {
			'ngInject';
			return Taxonomy.getClientUserCount();
		};
	}

	clearClientUserCount() {
		this.clearUsers();
		return this;
	}

	//
	// publishers
	//
	getPublishers() {
		if (!cache.publishers) {
			cache.publishers = this.Api.get('/users/publishers').then(publishers => {
				ensure.array(publishers).forEach(p => {
					const [emailPart] = String(p.email).split('@');
					p.fullName = `${p.fname} ${p.lname}`;
					p.$search = `${p.fname} ${p.lname} | ${emailPart} | ${p.lname} ${p.fname}`.toLowerCase();
				});
				return publishers;
			});
		}
		return cache.publishers;
	}

	static resourcifyPublishers() {
		return Taxonomy => {
			'ngInject';
			return Taxonomy.getPublishers();
		};
	}

	clearPublishers() {
		cache.publishers = undefined;
		return this;
	}

	//
	// domains
	//
	getDomains() {
		if (!cache.domains) {
			cache.domains = this.Api.get('/posts/domains');
		}
		return cache.domains;
	}

	static resourcifyDomains() {
		return Taxonomy => {
			'ngInject';
			return Taxonomy.getDomains();
		};
	}

	clearDomains() {
		cache.domains = undefined;
		return this;
	}
}
